import { Link, useSearchParams } from "wouter";
import { PageHeaderItem } from "../oss/Layout/Layout";
import { BackIcon, CloseIcon } from "./Icon";

export function PageHeaderBackButton(props: { href: string }) {
  const [params] = useSearchParams();
  const backHref = params.get("backTo") ?? props.href;

  return (
    <PageHeaderItem render={<Link transition href={backHref} />}>
      <BackIcon />
    </PageHeaderItem>
  );
}

export function PageHeaderCloseButton(props: { href: string }) {
  return (
    <PageHeaderItem render={<Link transition href={props.href} />}>
      <CloseIcon />
    </PageHeaderItem>
  );
}

export function PageHeaderNavButton(props: { backHref: string }) {
  const { backHref } = props;
  return <PageHeaderBackButton href={backHref} />;
}
